<template lang='html'>
<div class="app-card mb-0">
<div class="app-card-content">
    <v-list class="card-list" three-line>
        <v-list-tile px-0>
			<v-badge color="green" overlap>
		      <span slot="badge" >5</span>
		      <img height="60" width="60" src="/static/img/icon2.png" ></img>
		    </v-badge>
                          	
            <v-list-tile-content :class="'ml-2'">
                <v-list-tile-sub-title>
                    <div>
                        <h5 class="fw-bold text-gray">英国牛栏爱他美3段</h5>
                    </div>
                    <span class="mr-2">
                        <i class="ti-download mr-1"></i> 225 Sale</span>
                    <br>
                    <span class="mr-2">
                        <i class="ti-eye mr-1"></i> 280 Views
                    </span>
                </v-list-tile-sub-title>
            </v-list-tile-content>
			
            <v-list-tile-action>
                <h3 class="mb-0 fw-bold">$ 59</h3>
                <h4 class="mb-0 fw-bold">x2</h4>
                <h2 class="mb-0 fw-bold red--text">$108</h2>
            </v-list-tile-action>


            <v-list-tile-action>
                <v-menu origin="center center" transition="scale-transition" bottom>
                    <v-btn icon slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    
                    <v-list>
                        <v-list-tile @click="">
                            <v-icon class="mr-1">settings</v-icon>
                            <v-list-tile-title>Settings</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="">
                            <v-icon class="mr-1">more</v-icon>
                            <v-list-tile-title>View More</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.stop="">
                            <v-icon class="mr-1">notifications_off</v-icon>
                            <v-list-tile-title>Disable notifications</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-list-tile-action>
        </v-list-tile>
    </v-list>
</div>
</div>

</template>

<script>
/* eslint-disable */
export default {
    //template:``,
    name: '',
    props:{},
    computed:{},
    methods:{},
    components:{},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/components/product_item_list.vue